import { useTranslations } from 'use-intl';

export enum ObservationCode {
	AD = 'AD',
	CA = 'CA',
	CC = 'CC',
	CD = 'CD',
	CL = 'CL',
	CO = 'CO',
	CP = 'CP',
	CT = 'CT',
	CV = 'CV',
	FD = 'FD',
	FN = 'FN',
	FP = 'FP',
	FR = 'FR',
	GP = 'GP',
	IA = 'IA',
	IM = 'IM',
	IS = 'IS',
	LC = 'LC',
	LG = 'LG',
	LO = 'LO',
	LS = 'LS',
	MP = 'MP',
	NA = 'NA',
	NV = 'NV',
	PC = 'PC',
	PD = 'PD',
	PE = 'PE',
	PI = 'PI',
	PR = 'PR',
	RA = 'RA',
	RI = 'RI',
	RF = 'RF',
	RN = 'RN',
	RV = 'RV',
	SG = 'SG',
	UP = 'UP',
	VR = 'VR'
}

export const getObservationCodeText = (
	code: string | null | undefined,
	t: ReturnType<typeof useTranslations>
): string => {
	if (!code) return '';

	const codeMap: Record<string, string> = {
		[ObservationCode.AD]: t('ObservationCodeAD'),
		[ObservationCode.CA]: t('ObservationCodeCA'),
		[ObservationCode.CC]: t('ObservationCodeCC'),
		[ObservationCode.CD]: t('ObservationCodeCD'),
		[ObservationCode.CL]: t('ObservationCodeCL'),
		[ObservationCode.CO]: t('ObservationCodeCO'),
		[ObservationCode.CP]: t('ObservationCodeCP'),
		[ObservationCode.CT]: t('ObservationCodeCT'),
		[ObservationCode.CV]: t('ObservationCodeCV'),
		[ObservationCode.FD]: t('ObservationCodeFD'),
		[ObservationCode.FN]: t('ObservationCodeFN'),
		[ObservationCode.FP]: t('ObservationCodeFP'),
		[ObservationCode.FR]: t('ObservationCodeFR'),
		[ObservationCode.GP]: t('ObservationCodeGP'),
		[ObservationCode.IA]: t('ObservationCodeIA'),
		[ObservationCode.IM]: t('ObservationCodeIM'),
		[ObservationCode.IS]: t('ObservationCodeIS'),
		[ObservationCode.LC]: t('ObservationCodeLC'),
		[ObservationCode.LG]: t('ObservationCodeLG'),
		[ObservationCode.LO]: t('ObservationCodeLO'),
		[ObservationCode.LS]: t('ObservationCodeLS'),
		[ObservationCode.MP]: t('ObservationCodeMP'),
		[ObservationCode.NA]: t('ObservationCodeNA'),
		[ObservationCode.NV]: t('ObservationCodeNV'),
		[ObservationCode.PC]: t('ObservationCodePC'),
		[ObservationCode.PD]: t('ObservationCodePD'),
		[ObservationCode.PE]: t('ObservationCodePE'),
		[ObservationCode.PI]: t('ObservationCodePI'),
		[ObservationCode.PR]: t('ObservationCodePR'),
		[ObservationCode.RA]: t('ObservationCodeRA'),
		[ObservationCode.RI]: t('ObservationCodeRI'),
		[ObservationCode.RF]: t('ObservationCodeRF'),
		[ObservationCode.RN]: t('ObservationCodeRN'),
		[ObservationCode.RV]: t('ObservationCodeRV'),
		[ObservationCode.SG]: t('ObservationCodeSG'),
		[ObservationCode.UP]: t('ObservationCodeUP'),
		[ObservationCode.VR]: t('ObservationCodeVR')
	};

	return codeMap[code] || code;
};
